<template>
  <a class="navbar-brand" href="/">
    <svg
      viewBox="0 0 100 100"
      height="32"
      class="logo"
      fill="currentColor"
      alt="GridUnity Logo"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 73.038 26.459 C 72.079 25.274 70.34 25.091 69.155 26.051 L 61.083 32.587 L 42.794 47.398 C 41.608 48.357 41.426 50.096 42.386 51.281 L 47.184 57.207 C 48.144 58.392 49.883 58.575 51.068 57.615 L 69.357 42.805 L 84.168 61.094 C 85.128 62.279 86.866 62.462 88.052 61.502 L 93.977 56.703 C 95.162 55.743 95.344 54.005 94.385 52.82 L 73.038 26.459 Z M 69.152 63.441 L 73.95 69.368 C 74.909 70.553 74.727 72.292 73.542 73.252 L 55.253 88.062 L 47.59 94.268 C 46.179 95.41 44.109 95.192 42.966 93.781 L 11.939 55.465 L 5.733 47.803 C 4.59 46.392 4.808 44.322 6.219 43.18 L 52.606 5.616 C 53.792 4.656 55.53 4.839 56.49 6.024 L 61.289 11.949 C 62.248 13.135 62.066 14.873 60.88 15.833 L 24.71 45.123 C 23.3 46.266 23.082 48.336 24.225 49.746 L 44.91 75.29 C 46.052 76.701 48.122 76.918 49.533 75.776 L 65.268 63.033 C 66.453 62.075 68.191 62.257 69.152 63.441" />
    </svg>
    <div class="d-flex flex-column flex-sm-row column-gap-2">
      <span class="navbar-brand-org">HECO</span>
      <span class="navbar-brand-site">...</span>
    </div>
  </a>
</template>
